module.exports = __webpack_public_path__ + "static/media/favorite.3da83faf.svg";